// Custom hook to use the context
import { useContext } from 'react';
import {
  MultiSelectionContext,
  MultiSelectionContextType,
} from './MultiSelectionsProvider';

const useMultiSelection = (): MultiSelectionContextType => {
  return useContext(MultiSelectionContext);
};

export default useMultiSelection;
